<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="[ stack ]" data-cy="login-form">
  <dcr-text-field
    formControlName="email"
    type="email"
    label="E-mailadres / Gebruikersnaam"
    data-cy="input-login-form-email"
  ></dcr-text-field>

  <dcr-text-field
    formControlName="password"
    type="password"
    label="Wachtwoord"
    data-cy="input-login-form-password"
  ></dcr-text-field>

  <div *ngIf="error">
    <div class="[ error-container border border-error p-i-s p-b-2xs corner-s ][ body-large ]" data-cy="login-error">
      {{ error }}
    </div>
  </div>

  <button
    inline-button
    class="[ flex self-end ]"
    (click)="setForgotPassword()"
    type="button"
    data-cy="btn-login-form-request-password"
  >
    Wachtwoord vergeten?
  </button>

  <div class="[ cluster ]">
    <div class="[ justify-between ]">
      <dcr-filled-button type="submit" label="Aanmelden" [disabled]="!loginForm.valid" data-cy="btn-login-form-sign-in">
      </dcr-filled-button>
      <dcr-inline-button
        *ngIf="showRegister"
        label="Registreer als nieuwe leerling"
        routerLink="/registratie"
        data-cy="btn-login-form-register"
      >
      </dcr-inline-button>
    </div>
  </div>
</form>
